import { render, staticRenderFns } from "./ProductNew.vue?vue&type=template&id=0c49a1c4&scoped=true&"
import script from "./ProductNew.vue?vue&type=script&lang=js&"
export * from "./ProductNew.vue?vue&type=script&lang=js&"
import style0 from "./ProductNew.vue?vue&type=style&index=0&id=0c49a1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c49a1c4",
  null
  
)

export default component.exports